import React, { useState } from "react";

const NewsletterForm = ({ heading }) => {
  const [form, setForm] = useState({
    input_2: "",
    input_3: "",
    input_4: "",
    input_6: "Guest", // Default value for radio button
  });

  const [formError, setFormError] = useState({
    input_2: "",
    input_3: "",
    input_4: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false); // New state to track form submission

  const showThankYouMessage = () => {
    setIsSubmitted(true); // Set the form as submitted
  };

  const handleSubmit = () => {
    const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    setFormError({
      input_2: form.input_2 === "" ? "Please enter first name." : "",
      input_3: form.input_3 === "" ? "Please enter last name." : "",
      input_4:
        form.input_4 === "" || !form.input_4.match(validRegex)
          ? "Please enter valid email."
          : "",
    });

    if (form.input_4 !== "" && form.input_2 !== "" && form.input_3 !== "") {
      setIsLoading(true);

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      };

      const url = `${process.env.GATSBY_SITE_URL}wp-json/gf/v2/forms/${process.env.GATSBY_NEWSLETTER_FORM_ID}/submissions`;

      fetch(url, requestOptions)
        .then((response) => {
          setIsLoading(false);
          if (response.status === 200) {
            showThankYouMessage();
          }
        })
        .catch(() => {
          setIsLoading(false);
        });
    }
  };

  const handleRadioChange = (e) => {
    setForm({ ...form, input_6: e.target.value });
  };

  return (
    <div className="newsletter p-10 smscreen2:px-50">
      {isSubmitted ? (
        <p className="newsletter-message text-white-100">Thank you for signing up to our newsletter!</p>
      ) : (
          <div className="flex flex-wrap items-center justify-between">
            {heading && (
              <h6 className="text-grey-400 text-30 font-800 font-headingSecondary">
                {heading}
              </h6>
            )}
            <div className="gform_wrapper flex flex-wrap ipad:flex-col justify-between items-start ipad:items-start">
              <div className="gform_body w-full px-50 xlscreen:pl-0 mdscreen:pr-0">
                <ul className="flex flex-wrap -ml-50">
                  <li>
                    <input
                      type="text"
                      value={form.input_2}
                      onChange={(e) => {
                        setForm({ ...form, input_2: e.target.value });
                        setFormError({ ...formError, input_2: "" });
                      }}
                      placeholder="First Name"
                    />
                    {formError.input_2 && (
                      <div className="error">
                        <span className="text-red">{formError.input_2}</span>
                      </div>
                    )}
                  </li>
                  <li>
                    <input
                      type="text"
                      value={form.input_3}
                      onChange={(e) => {
                        setForm({ ...form, input_3: e.target.value });
                        setFormError({ ...formError, input_3: "" });
                      }}
                      placeholder="Last Name"
                    />
                    {formError.input_3 && (
                      <div className="error">
                        <span className="text-red">{formError.input_3}</span>
                      </div>
                    )}
                  </li>
                  <li>
                    <input
                      type="text"
                      value={form.input_4}
                      onBlur={(e) => {
                        const pattern =
                          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                        if (!pattern.test(e.target.value)) {
                          setForm({ ...form, input_4: "" });
                          setFormError({
                            ...formError,
                            input_4: "Please enter valid email.",
                          });
                        }
                      }}
                      onChange={(e) => {
                        setForm({ ...form, input_4: e.target.value });
                        setFormError({ ...formError, input_4: "" });
                      }}
                      placeholder="Email Address"
                    />
                    {formError.input_4 && (
                      <div className="error">
                        <span className="text-red">{formError.input_4}</span>
                      </div>
                    )}
                  </li>
                  <li className="radio-group">
                    <label className="radiol-label">
                      <input
                        type="radio"
                        name="popupUserType"  // Unique name for popup form
                        value="Guest"
                        checked={form.input_6 === "Guest"}
                        onChange={handleRadioChange}
                        className="radio-input"
                      />
                      Guest
                    </label>
                    <label className="radiol-label">
                      <input
                        type="radio"
                        name="popupUserType"  // Unique name for popup form
                        value="Agent"
                        checked={form.input_6 === "Agent"}
                        onChange={handleRadioChange}
                        className="radio-input"
                      />
                      Agent
                    </label>
                  </li>
                </ul>
              </div>
              <div className="gform_footer smscreen2:mt-15 ipad:mt-15 smscreen:w-[80%]">
                <button
                  className="btn btn-grey mdscreen:w-full"
                  onClick={handleSubmit}
                >
                  <span>{isLoading ? "Loading" : "Sign Up"}</span>
                </button>
              </div>
              <div className="newsletter-form mt-10"></div>
            </div>
          </div>
      )}
    </div>
  );
};

export default NewsletterForm;